export default "__VITE_ASSET__abghuw67__"